export default __webpack_public_path__ + "example_image.png";